/// <amd-module name="TFS/Token/PatTokenPage/Context/PatPageContext" />
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IPatPageContextValue {
    readonly pageContext: IVssPageContext;
}

const PatPageContext = React.createContext<IPatPageContextValue>(undefined as never);

export type IPatPageProviderProps = Partial<IPatPageContextValue>;


export class PatPageProvider extends React.PureComponent<IPatPageProviderProps, {}> {
    constructor(props: IPatPageProviderProps) {
        super(props);

        if (!props.pageContext) {
            throw new Error("GlobalContext was not well defined");
        }
    }

    public render(): JSX.Element {
        return (
            <PatPageContext.Provider
                value={{
                    ...this.props,
                } as IPatPageContextValue}
            >
                {this.props.children}
            </PatPageContext.Provider>);
    }
}

export const PatPageConsumer = PatPageContext.Consumer;

